import {subMaoMsg$} from '@/raw/mao-sub-users';
import {throttleTime, map, scan, startWith, filter} from 'rxjs/operators';
import {combineLatest} from 'rxjs';
import {indexPricesCache$} from '@/price-index/price-index';
import {currenciesCurrencyCache$} from '@/config';
import {fiat$} from '@/state/fiat';
import {calcTotalAssets} from '@/assets/calc';

// 净资产 valueEv = balanceEv - borrowedEv - cumInterestEv
const subUsersAssetsCache$ = subMaoMsg$.pipe(
  scan((p, c) => {
    const wallets = c.data.wallets.map((o) => ({
      ...o,
      valueEv: Number(o.balanceEv) - Number(o.borrowedEv) - Number(o.cumInterestEv),
    }));
    p.set(c.userId, wallets);
    return p;
  }, new Map()),
  startWith(new Map())
);

export const spotTotalAssetsSubs$ = combineLatest([
  subUsersAssetsCache$,
  indexPricesCache$,
  currenciesCurrencyCache$,
  fiat$,
]).pipe(
  throttleTime(100),
  map(([assets, indexPricesCache, currencies, fiat]) => {
    const allAssets = [].concat(...assets.toArray());
    return calcTotalAssets(allAssets, indexPricesCache, currencies, fiat, true);
  }),
  filter(Boolean)
);

// 计算所有子账号钱包币对总和
export const allSubWalletsCache$ = subUsersAssetsCache$.pipe(
  map((assetsCache) => {
    const assets = [].concat(...assetsCache.toArray());
    return sumValuesByCurrency(assets);
  }),
  startWith(new Map())
);

function sumValuesByCurrency(data) {
  return data.reduce((result, item) => {
    const currency = item.currency;
    const value = parseFloat(item.balanceEv);
    result.set(currency, (result.get(currency) || 0) + value);
    return result;
  }, new Map());
}
